import { createFileRoute, redirect } from '@tanstack/react-router';

import { HOME_ROUTE } from '@/lib/redirect';

/** La raíz lleva a Entrenar, donde se muestra el acceso a la rutina activa. */
export const Route = createFileRoute('/_app/')({
  beforeLoad: () => {
    throw redirect({ href: HOME_ROUTE, replace: true });
  },
});
